import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useAppStore } from "@hooks/useAppStore";
import { useQuery } from "@tanstack/react-query";
import { getReport } from "../api";
import type { PrintableReportData } from "../components/print/PrintableReport";

export function useLegacyReportData(
	sessionId: number,
): PrintableReportData | undefined {
	const {
		userPublicMetadataId: userId,
		email,
		userLogicalId,
	} = useAuthContext();
	const {
		currentExamContext: { examName },
	} = useExamContext();
	const appName = useAppStore((state) => state.app.name);

	const { data: reportDetails } = useQuery({
		queryKey: ["report", String(sessionId), userId],
		queryFn: () => getReport({ sessionId, userId: userId! }),
		enabled: Boolean(userId),
	});

	if (!(reportDetails && examName && userLogicalId)) {
		return undefined;
	}

	return {
		id: userLogicalId,
		email,
		assessment: reportDetails.examName,
		assessmentId: reportDetails.numericId,
		appName,
		exam: examName,
		accuracy: `${reportDetails.accuracy ?? 0}%`,
		tags: reportDetails.tagDetails ?? [],
		numericId: reportDetails.numericId,
	};
}
